import React, { useEffect, useRef } from 'react';
/* eslint import/no-webpack-loader-syntax: off */
import mapboxgl from '!mapbox-gl';
import MapboxGeocoder from '@mapbox/mapbox-gl-geocoder';
import '@mapbox/mapbox-gl-geocoder/dist/mapbox-gl-geocoder.css';
import 'mapbox-gl/dist/mapbox-gl.css';
// href="https://api.mapbox.com/mapbox-gl-js/plugins/mapbox-gl-geocoder/v5.0.0/mapbox-gl-geocoder.css" type="text/css">

const styles = {
  width: '100%',
  height: 'calc(100vh)'
};

// from https://github.com/darkskyapp/string-hash
export const hashCode = object_ => {
  const str = JSON.stringify(object_);
  let hash = 5381;
  let i = str.length;
  if (i === 0) return hash;
  while (i) {
    hash = (hash * 33) ^ str.charCodeAt(--i);
  }
  /* JavaScript does bitwise operations (like XOR, above) on 32-bit signed
   * integers. Since we want the results to be always positive, convert the
   * signed int to an unsigned by doing an unsigned bitshift. */
  return hash >>> 0;
};

const clickListener = (map, setSelection) => {
  const layerNames = ['3d-building-layer'];
  if (map.getLayer('line-layer')) layerNames.push('line-layer');

  map.on('click', function (e) {
    // set bbox as 5px reactangle area around clicked point
    var bbox = [
      [e.point.x - 5, e.point.y - 5],
      [e.point.x + 5, e.point.y + 5]
    ];
    var features = map.queryRenderedFeatures(bbox, {
      layers: layerNames
    });

    const clicked = features.map(f => f.properties.id);
    // don't allow multi-select (confusing)
    if (clicked.length > 0) {
      setSelection([clicked[0]]);
    }
  });

  layerNames.forEach(layerName => {
    map.on('mouseenter', layerName, function () {
      map.getCanvas().style.cursor = 'pointer';
    });
    map.on('mouseleave', layerName, function () {
      map.getCanvas().style.cursor = '';
    });
  });

  // map.on('mouseenter', 'line-layer', function() {
  //   map.getCanvas().style.cursor = 'pointer';
  // });
  // map.on('mouseleave', 'line-layer', function() {
  //   map.getCanvas().style.cursor = '';
  // });
};

const extrusionFilters = [
  ['==', ['geometry-type'], 'Polygon'],
  ['>', ['get', '_height'], 0]
];

const MapboxGLMap = props => {
  const mapContainer = useRef(null);
  const mapRef = useRef(null);

  const [loaded, setLoaded] = React.useState(false);

  const { center, zoom, bounds, layers, selection, setSelection, style, pitch, cb } = props;

  useEffect(() => {
    // process.env.REACT_APP_MAPBOX_KEY;
    mapboxgl.accessToken = 'pk.eyJ1IjoibWlrZXktYnJpc2JhbmVkZXZlbG9wbWVudCIsImEiOiJjazlvdmJldTcwNHV4M2RxcWhjeWNvenVmIn0.76YQj7ojsNwMv0czBeMPUA';
    const map = new mapboxgl.Map({
      container: mapContainer.current,
      style: style ?? 'mapbox://styles/mikey-brisbanedevelopment/ck9oul40k12ze1ipb7osra1lo',
      center: center ?? [0, 0],
      zoom: zoom ?? 0,
      pitch: pitch ?? 0
    });
    mapRef.current = map;
    window.map = map;

    // Add the control to the map.
    map.addControl(
      new MapboxGeocoder({
        accessToken: mapboxgl.accessToken,
        mapboxgl: mapboxgl
      }),
      'top-right'
    );

    map.on('style.load', () => {
      // map.on("load", () => {
      map.resize();
      setLoaded(true);
    });
    clickListener(map, setSelection);

    return () => {
      map.remove();
    };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const { current: map } = mapRef;
    if (!map) return;
    // const filter = ['in', 'id', ['literal', selection]]
    const filter = ['any', ...selection.map(id => ['==', ['get', 'id'], id])];
    const notFilter = ['all', ...selection.map(id => ['!=', ['get', 'id'], id])];

    map.getLayer('3d-building-layer') && map.setFilter('3d-building-layer', ['all', ...extrusionFilters, notFilter]);
    map.getLayer('line-layer') && map.setFilter('line-layer', notFilter);
    map.getLayer('3d-building-layer-selected') && map.setFilter('3d-building-layer-selected', ['all', ...extrusionFilters, filter]);
    map.getLayer('line-layer-selected') && map.setFilter('line-layer-selected', filter);
  }, [selection, layers, loaded]);

  // const layerKey = hashCode(layers);
  const layerKey = layers.map(l => l.id).join('-');

  useEffect(() => {
    const { current: map } = mapRef;
    // if (!(map && map.isStyleLoaded())) return
    if (!map) return;

    try {
      layers.forEach(layer => {
        if (map.getLayer(layer.id)) {
          map.removeLayer(layer.id);
        }
        if (map.getSource(layer.id)) {
          map.removeSource(layer.id);
        }
        map.addLayer(layer);
      });
    } catch {
      // console.log('map not yet loaded')
    }

    cb && cb(map);

    // TODO update map.getSource('points').setData(geoJSON)
  // note this will rerender entire app if we put in deps
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [layerKey, loaded]);

  // Update bounds to match incoming bounds
  // useEffect(() => {
  //   if (!bounds) return
  //   const { current: map } = mapRef
  //   if (!map) return
  //   map.fitBounds(bounds, { padding: 100, duration: 2000 })
  // }, [bounds])
  useEffect(() => {
    if (!center) return;
    const { current: map } = mapRef;
    if (!map) return;
    map.setCenter(center);
  }, [center]);

  return <div ref={el => (mapContainer.current = el)} style={styles} />;
};

export default MapboxGLMap;
